const MODAL_OFFSET = 28;

// Adjusts map popup position relative to selected marker
export function getPixelPositionOffset(offsetWidth: number, offsetHeight: number) {
  return {
    x: MODAL_OFFSET,
    y: -(offsetHeight / 2),
  };
}
